var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContractIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.218 5.038l-3.902 1.289a1.294 1.294 0 01-1.58-.688 1.311 1.311 0 01.595-1.72l3.779-1.901a2.635 2.635 0 012.093-.121l5.595 2.046m.028 7.69l-5.805 1.109 5.805-1.11z",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.146 11.642h2.75l3.951 4.428a1.511 1.511 0 002.653-.986v-.692l.197.08a1.863 1.863 0 002.555-1.73h.55a1.652 1.652 0 001.32-2.642l-3.53-4.524m-2.686-1.948l-.403-.332a2.36 2.36 0 00-2.277-.29L4.219 5.01",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.252 12.742L14.6 11.09M.844 3.094h2.25a1.08 1.08 0 011.125 1.03v7.22a1.082 1.082 0 01-1.125 1.031H.844V3.094zm25.312 9.281h-2.25a1.082 1.082 0 01-1.125-1.032V4.124a1.08 1.08 0 011.125-1.03h2.25v9.281zM13.5 14.392l-1.1-1.1 1.1 1.1z",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgContractIcon;